import TopBar from "./components/TopBar";
import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import RankEntry from "./components/RankEntry";
import FeaturedPicks from "./components/FeaturedPicks";
import PopularRanking from "./components/PopularRanking";
import DoubanRanking from "./components/DoubanRanking";
import GenreBrowse from "./components/GenreBrowse";
import Collections from "./components/Collections";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TopBar />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <RankEntry />
        <FeaturedPicks />
        <PopularRanking />
        <DoubanRanking />
        <GenreBrowse />
        <Collections />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}